import React from "react";
import { useAppStore } from "@/store/appContext";

const FloatingFooter: React.FC = () => {
  const { localCart, openConfirmationSheet } = useAppStore();

  const handleConfirmDonation = () => {
    if (localCart.items.length === 0) return;
    openConfirmationSheet();
  };

  return (
    <div className="floating-footer">
      <div className="footer-content">
        <div className="cart-summary">
          <span className="total-quantity">
            {localCart.totalQuantity} items
          </span>
          <span className="total-price">
            ${localCart.totalPrice.toFixed(2)}
          </span>
        </div>

        <button
          className="confirm-donation-btn"
          disabled={localCart.totalQuantity === 0}
          onClick={handleConfirmDonation}
        >
          Confirm Donation
        </button>
      </div>
    </div>
  );
};

export default FloatingFooter;
